<template>
    <div class="hero-slider">
        <div class="swiper-container" ref="slider">
            <div class="swiper-wrapper">
                <div
                    class="hero-slide swiper-slide"
                    ref="slide"
                    v-for="(item, index) in data"
                    :key="index"
                >
                    <div v-if="item.type === 'photo'" class="hero-slide__img swiper-lazy" :data-background="item.image"></div>
                    <video
                        v-if="item.type === 'video'"
                        class="hero-slide__video"
                        ref="video"
                        loop
                        muted
                        playsinline
                    >
                        <source v-if="item.video.mp4" :src="item.video.mp4" :data-src="item.video.mp4" class="swiper-lazy" type="video/mp4">
                        <source v-if="item.video.webm" :src="item.video.webm" :data-src="item.video.webm" class="swiper-lazy" type="video/webm">
                        <source v-if="item.video.ogv" :src="item.video.ogv" :data-src="item.video.ogv" class="swiper-lazy" type="video/ogg">
                    </video>
                    <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                    <a
                        :href="item.link"
                        class="hero-slide__info"
                        :data-target="`ClickSlide${index + 1}MainPage`"
                        :data-label="`slide${index + 1}`"
                        data-category="slider"
                        @click.self="targetAnalytics"
                    >
                        <div class="container">
                            <p class="hero-slide__tag" v-if="item['general-news']" v-html="text.caption"></p>
                            <p class="hero-slide__title" v-html="item.name"></p>
                            <p class="hero-slide__text" v-html="item.detail"></p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="hero-slider__pagination" ref="pagination">
            <div class="container">
                <div :class="[
                    'hero-slider-pagination',
                    { 'hero-slider-pagination--filled' : !isAutoplay }
                ]">
                    <div
                        :class="[
                            'hero-slider-pagination__item',
                            { 'hero-slider-pagination__item--active' : index === currentSlideIndex }
                        ]"
                        v-for="(item, index) in data" :key="index"
                        @click="changeSlide(index)"
                    >
                        <div class="hero-slider-pagination__timer">
                            <span class="hero-slider-pagination__line"></span>
                        </div>
                        <p class="hero-slider-pagination__text" v-html="item.signature"></p>
                    </div>
                </div>
                <div class="hero-slider-pagination hero-slider-pagination--mobile"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'
import Velocity from 'velocity-animate'
import { throttle } from 'throttle-debounce'
import { polyfillObjectFitVideo, targetAnalytics } from '@/utils/util.js'

export default {
    name: 'hero-slider',
    props: {
        data: {
            type: Array
        },
        effect: {
            type: String,
            default: 'slide'
        },
        loop: {
            type: Boolean,
            default: true
        },
        time: {
            type: Number,
            default: 7000
        },
        speed: {
            type: Number,
            default: 300
        }
    },
    data() {
        return {
            slider: null,
            currentSlideIndex: 0,
            isAutoplay: true,
            text: {
                caption: localize({
                    'ru': 'Главная новость',
                    'en': 'Main news'
                })
            },
            targetAnalytics
        }
    },
    created () {
        window.addEventListener("DOMContentLoaded", this.listenHandler())
        window.addEventListener("resize", this.listenHandler())
    },
    mounted () {
        this.$nextTick(function () {
            this.initSlider()
            polyfillObjectFitVideo('.hero-slide__video')
        })

        const _this = this;
        document.addEventListener("visibilitychange", function() {
            if (_this.isAutoplay) {
                if (document.hidden) {
                    _this.stopTimer()
                    _this.slider.autoplay.stop()
                } else {
                    _this.slider.autoplay.start()
                    _this.startTimer()
                }
            }
        });

        window.addEventListener("resize", function() {
            _this.startTimer()
        });
    },
    methods: {
        initSlider() {
            const _this = this;
            this.slider = new Swiper(this.$refs.slider, {
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 2,
                },
                updateOnImagesReady: false,
                observer: true,
                observeParents: true,
                autoHeight: false,
                slidesPerView: 1,
                effect: this.effect,
                fadeEffect: {
                    crossFade: true
                },
                simulateTouch: false,
                loop: this.loop,
                speed: this.speed,
                autoplay: {
                    delay: this.time,
                    disableOnInteraction: false,
                    waitForTransition: false
                },
                pagination: {
                    el: '.hero-slider-pagination--mobile',
                    type: 'bullets',
                },
                on: {
                    init() {
                        _this.startTimer()

                        const currentVideo = this.slides[this.activeIndex].querySelector('video')
                        if (currentVideo) currentVideo.play()
                    },
                    slideChange() {
                        if (_this.isAutoplay) {
                            let index
                            this.activeIndex > _this.data.length ? index = 0 : index = this.activeIndex - 1
                            _this.currentSlideIndex = index
                            _this.stopTimer()
                            _this.startTimer()
                        }

                        _this.stopAndStartVideo(this)
                    },
                },
            })
        },
        stopAndStartVideo(slider) {
            const sliderVideos = this.$refs.video
            if (sliderVideos) {
                sliderVideos.forEach(item => {
                    item.pause()
                })
            }

            const currentVideo = slider.slides[slider.activeIndex].querySelector('video')
            if (currentVideo) {
                this.$nextTick(function () {
                    currentVideo.currentTime = 0
                    currentVideo.play()
                })
            }
        },
        changeSlide (index) {
            this.currentSlideIndex = index
            this.isAutoplay = false
            this.stopTimer()
            this.slider.autoplay.stop()
            this.slider.slideTo(index + 1)
        },
        startTimer() {
            this.stopTimer()
            const activeItem = document.querySelectorAll('.hero-slider-pagination__item')[this.currentSlideIndex]
            const line = activeItem.querySelector('.hero-slider-pagination__line')

            Velocity(line,{ width: '100%' }, this.time)
        },
        stopTimer() {
            const lines = document.querySelectorAll('.hero-slider-pagination__line')

            Velocity(lines, 'stop')
            Velocity(lines, { width: '0%' }, 0)
        },
        styleHelperImage (image) {
            let style = ''

            if (image) {
                style = `background-image: url('${image}');`
            }

            return style
        },
        listenHandler () {
            return throttle(500, e => {
                const paginationHeight = this.$refs.pagination.offsetHeight
                const slides = document.querySelectorAll('.hero-slide__info')

                if (window.innerWidth > 1120) {
                    slides.forEach(item => {
                        item.style.bottom = `${paginationHeight + 80}px`
                    })
                } else if (window.innerWidth > 768 && window.innerWidth <= 1120) {
                    slides.forEach(item => {
                        item.style.bottom = `${paginationHeight + 60}px`
                    })
                } else {
                    slides.forEach(item => {
                        item.style.bottom = `25px`
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss" src="./hero-slider.scss"></style>



// WEBPACK FOOTER //
// frontend/components/hero-slider/hero-slider.vue